import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { KEY_A } from '@/constants';
import { usePopupOpen } from '@/hooks';
import { checkCtrlPressed, isActiveElementEditable } from '@/helpers';
import { selectAllSectionsThunk } from '@/actions';

export default () => {
  const dispatch = useDispatch();
  const isSomePopupOpen = usePopupOpen();

  useEffect(() => {
    if (isSomePopupOpen) {
      removeListener();
    } else {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      removeListener();
    };
  });

  const removeListener = () => {
    document.removeEventListener('keydown', handleKeyDown);
  };

  const handleKeyDown = event => {
    const isCtrlPressed = checkCtrlPressed(event);
    if (!isActiveElementEditable()) {
      if (isCtrlPressed && event.code === KEY_A) {
        event.preventDefault();
        dispatch(selectAllSectionsThunk());
      }
    }
  };
};
